/**
 * Shared quad-tab button (Flow spec, Notion 3927). Used by
 * `AccountDrillDown`'s right quad tab strip and, from the plan's next unit
 * (U8), the `AccountIntelPanel` Summary/All toggle — see
 * `plans/2026-09-23-002-rep-prompt-overrides-and-account-intelligence-summary-plan.md`
 * Key Technical Decision 10.
 */
export function QuadTab({ label, active, onClick }: { label: string; active: boolean; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-3 py-1.5 text-[12px] border-b-2 -mb-px ${
        active
          ? 'border-content-primary dark:border-nightshade-100 text-content-primary dark:text-nightshade-100 font-semibold'
          : 'border-transparent text-content-tertiary dark:text-nightshade-500 hover:text-content-primary dark:hover:text-nightshade-100'
      }`}
    >
      {label}
    </button>
  );
}
